import { render, staticRenderFns } from "./ReportBody.vue?vue&type=template&id=c1d4cf42&scoped=true&"
import script from "./ReportBody.vue?vue&type=script&lang=js&"
export * from "./ReportBody.vue?vue&type=script&lang=js&"
import style0 from "./ReportBody.vue?vue&type=style&index=0&id=c1d4cf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d4cf42",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem,QInput,QBtn,QTooltip,QCheckbox} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem,QInput,QBtn,QTooltip,QCheckbox}, component.options.components || {})
